<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期间</label>
            <span class="weui-form-preview__value">{{initData.cm_yearmonth}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.cu_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{initData.cu_sellername}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.cm_currency}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期初</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_begin}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本期增加</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_add}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <em class="weui-form-preview__value">本期减少</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收款</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_reduce_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">贴现</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_reduce_dis}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">背书转让</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_reduce_tr}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">退票</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_reduce_back}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期末</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_end}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>